import { useSelector } from 'react-redux';
import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Container } from '@mui/system';
import { Box, Button, Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
import { dispatch } from '../../../redux/store';
//  import { varFade } from '../../animate';
// import useLocales from '../../../hooks/useLocales';
import { getArticlePreview } from '../../../redux/slices/articles';
import { MotionViewport } from '../../animate';
import useLocales from '../../../hooks/useLocales';

LinkedArticles.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
};

const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  margin: theme.spacing(2),
  width: '100%',
  '&:hover': {
    background: theme.palette.primary.dark,
  },
}));

const CustomBox = styled(Grid)(() => ({
  //  padding: theme.spacing(3, 3),
  borderRadius: '8px',
  // border: `1px solid ${theme.palette.text.primary}`,
  // boxShadow: `0px 1px 8px ${theme.palette.text.secondary}`,
}));

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  backgroundColor: theme.palette.background.paper,
}));

export default function LinkedArticles({ title, data }) {
  const { translate, currentLang } = useLocales();
  const { linked } = useSelector((state) => state.articles);

  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if (data && data.length) {
      data.forEach((item) => {
        dispatch(getArticlePreview(item.articleKey, { locale: currentLang.getValue }));
      });
    }
  }, [data, currentLang.getValue]);

  return (
    <RootStyle>
      <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
        <m.div /* variants={varFade().inUp} */>
          <CustomBox container>
            <Grid item xs={12} className="text-left">
              <Typography variant="h4" sx={{ padding: '6px' }}>
                {title}
              </Typography>
            </Grid>
            <Box>
              {showMore
                ? linked?.map((item, index) => <LinkedArticle key={index} data={item} />)
                : linked?.slice(0, 5).map((item, index) => <LinkedArticle key={index} data={item} />)}
              {linked.length > 5 && (
                <CustomButton onClick={() => setShowMore(!showMore)}>
                  {showMore ? translate('default.showLess') : translate('default.showMore')}
                </CustomButton>
              )}
            </Box>
          </CustomBox>
        </m.div>
      </Container>
    </RootStyle>
  );
}

LinkedArticle.propTypes = {
  data: PropTypes.object,
};

function LinkedArticle({ data }) {
  const { translate } = useLocales();
  const pathArticles = window.location.pathname.includes('en/')
    ? `/en${translate('urls.articles')}`
    : translate('urls.articles');
  if (data && data.title) {
    return (
      <Grid item xs={12} className="text-left">
        <Box sx={{ display: 'flex', alignItems: 'center', ml: 3 }}>
          •
          <Link style={{ textDecoration: 'none' }} to={`${pathArticles}/${data.key}`}>
            <Typography variant="body1" sx={{ textDecoration: 'underline', padding: '6px', fontWeight: 'bold' }}>
              {data.title}
            </Typography>
          </Link>
        </Box>
      </Grid>
    );
  }
  return null;
}
